import { c as _c } from "react/compiler-runtime";
import React from 'react';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import IconMobileGrid3x from 'components/icons/iconMobileGrid3x';
import MobileFiltersButton from 'components/consumer/MobileFiltersButton';
import ExpandableModalOptions from 'components/consumer/ExpandableModalOptions';
import ShopByMobileFiltersBar from 'components/consumer/ShopByMobileFiltersBar';
import PropTypes from 'prop-types';
import getTabId from 'commons/getTabId';
import cx from 'classnames';
import MobileOnly from 'components/consumer/MobileOnly';
import TabletAndDesktopOnly from 'components/consumer/TabletAndDesktopOnly';
import ColorFilters from './ColorFilters';
import DesktopTierFilters from './DesktopTierFilters';
import DesktopGradeFilters from './DesktopGradeFilters';
import FeaturesFilters from './FeaturesFilters';
const MATERIAL_TYPES = {
  FABRIC: 'Fabric',
  LEATHER: 'Leather'
};
const FabricPageHeader = props => {
  const $ = _c(81);
  const {
    selectedMaterialType,
    selectedColors,
    selectedFeatures,
    selectedTiers,
    selectedGrades,
    selectedFabric,
    fabricColors,
    fabricTiers,
    leatherGrades,
    sortBy,
    sortByOptions,
    showFavorites,
    numberOfActiveFilters,
    showColorFilters,
    showFeaturesFilters,
    showTierFilters,
    showGradeFilters,
    isMobileSortByOpen,
    mobileItemsPerRow,
    mobileButtonItems,
    bannerHeight,
    setSortBy,
    toggleSelectedColor,
    toggleSelectedFeature,
    toggleSelectedTier,
    toggleSelectedGrade,
    toggleMobileSortByOpen,
    toggleMobileItemsPerRow,
    toggleMobileFiltersOpen
  } = props;
  const showMobileFiltersBar = selectedMaterialType === MATERIAL_TYPES.FABRIC || selectedMaterialType === MATERIAL_TYPES.LEATHER;
  let t0;
  if ($[0] !== sortBy || $[1] !== sortByOptions) {
    t0 = sortByOptions.find(sortByOption => sortByOption.value === sortBy)?.label || sortByOptions[0]?.label || "Popular";
    $[0] = sortBy;
    $[1] = sortByOptions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const selectedSortByLabel = t0;
  const t1 = bannerHeight !== 0;
  const t2 = bannerHeight === 0;
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = cx("md:hidden sticky z-10 bg-white transition-[transform_.2s_ease-in-out]", {
      "top-0": t1,
      "top-[60px]": t2
    });
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedMaterialType) {
    t4 = getTabId(selectedMaterialType, "FabricsPage");
    $[6] = selectedMaterialType;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== mobileButtonItems || $[9] !== t4) {
    t5 = <ToggleTabGroup aria-label="Upholstery" items={mobileButtonItems} selectedTab={t4} />;
    $[8] = mobileButtonItems;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isMobileSortByOpen || $[12] !== mobileItemsPerRow || $[13] !== numberOfActiveFilters || $[14] !== selectedMaterialType || $[15] !== selectedSortByLabel || $[16] !== showMobileFiltersBar || $[17] !== toggleMobileFiltersOpen || $[18] !== toggleMobileItemsPerRow || $[19] !== toggleMobileSortByOpen) {
    t6 = showMobileFiltersBar && <ShopByMobileFiltersBar><MobileFiltersButton onClick={() => toggleMobileFiltersOpen()} numberOfActiveFilters={numberOfActiveFilters} /><span className={cx("text-sm font-bold items-center bg-white border border-solid rounded-sm text-gray flex justify-center p-3 cursor-pointer", {
        "border-gray-light6": !isMobileSortByOpen,
        "border-brand": isMobileSortByOpen
      })} role="presentation" onClick={() => toggleMobileSortByOpen(!isMobileSortByOpen)}><span className="h-full">{`Sort by ${selectedSortByLabel}`}</span></span>{selectedMaterialType === MATERIAL_TYPES.FABRIC && <span className="items-center flex flex-1 justify-end"><span className="bg-none items-center bg-white border-0 flex justify-center ml-[3px] focus-visible:outline-offset-4" role="presentation" onClick={() => toggleMobileItemsPerRow()}>{mobileItemsPerRow === 1 ? <IconMobileGrid1x /> : mobileItemsPerRow === 2 ? <IconMobileGrid2x /> : <IconMobileGrid3x />}</span></span>}</ShopByMobileFiltersBar>;
    $[11] = isMobileSortByOpen;
    $[12] = mobileItemsPerRow;
    $[13] = numberOfActiveFilters;
    $[14] = selectedMaterialType;
    $[15] = selectedSortByLabel;
    $[16] = showMobileFiltersBar;
    $[17] = toggleMobileFiltersOpen;
    $[18] = toggleMobileItemsPerRow;
    $[19] = toggleMobileSortByOpen;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== isMobileSortByOpen || $[22] !== setSortBy || $[23] !== showMobileFiltersBar || $[24] !== sortBy || $[25] !== sortByOptions || $[26] !== toggleMobileSortByOpen) {
    t7 = showMobileFiltersBar && <div className="relative max-[767px]:bg-white"><ExpandableModalOptions isOpen={isMobileSortByOpen && showMobileFiltersBar} onClose={() => toggleMobileSortByOpen(false)} label="Sort By" options={sortByOptions.map(t8 => {
        const {
          label,
          value
        } = t8;
        return {
          label,
          id: label,
          isSelected: sortBy === value,
          onClick: () => {
            toggleMobileSortByOpen(false);
            setSortBy(value);
          }
        };
      })} /></div>;
    $[21] = isMobileSortByOpen;
    $[22] = setSortBy;
    $[23] = showMobileFiltersBar;
    $[24] = sortBy;
    $[25] = sortByOptions;
    $[26] = toggleMobileSortByOpen;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t3 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <MobileOnly><div className={t3}>{t5}{t6}{t7}</div></MobileOnly>;
    $[28] = t3;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] !== mobileButtonItems) {
    t9 = mobileButtonItems.map(_temp);
    $[33] = mobileButtonItems;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const t10 = showFavorites ? "Favorites" : selectedMaterialType;
  let t11;
  if ($[35] !== t10 || $[36] !== t9) {
    t11 = <ShopByHeaderSection label="Show Me"><ToggleButtonGroup aria-label="fabric filters" items={t9} selectedItem={t10} className="MaterialListToggleGroup" /></ShopByHeaderSection>;
    $[35] = t10;
    $[36] = t9;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== setSortBy || $[39] !== sortByOptions) {
    let t13;
    if ($[41] !== setSortBy) {
      t13 = t14 => {
        const {
          label: label_1,
          value: value_0
        } = t14;
        return {
          label: label_1,
          id: value_0,
          contentId: value_0,
          onClick: () => {
            setSortBy(value_0);
          }
        };
      };
      $[41] = setSortBy;
      $[42] = t13;
    } else {
      t13 = $[42];
    }
    t12 = sortByOptions.map(t13);
    $[38] = setSortBy;
    $[39] = sortByOptions;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[43] !== sortBy || $[44] !== t12) {
    t13 = <ShopByHeaderSection label="Sort By"><ToggleButtonGroup aria-label="swatches sortby" items={t12} selectedItem={sortBy} /></ShopByHeaderSection>;
    $[43] = sortBy;
    $[44] = t12;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== fabricColors || $[47] !== selectedColors || $[48] !== selectedFabric || $[49] !== selectedMaterialType || $[50] !== showColorFilters || $[51] !== toggleSelectedColor) {
    t14 = selectedMaterialType === MATERIAL_TYPES.FABRIC && showColorFilters && <ColorFilters fabricColors={fabricColors} toggleSelectedColor={c => toggleSelectedColor(c)} selectedColors={selectedColors} selectedFabric={selectedFabric} />;
    $[46] = fabricColors;
    $[47] = selectedColors;
    $[48] = selectedFabric;
    $[49] = selectedMaterialType;
    $[50] = showColorFilters;
    $[51] = toggleSelectedColor;
    $[52] = t14;
  } else {
    t14 = $[52];
  }
  let t15;
  if ($[53] !== selectedFabric || $[54] !== selectedFeatures || $[55] !== selectedMaterialType || $[56] !== showFeaturesFilters || $[57] !== toggleSelectedFeature) {
    t15 = selectedMaterialType === MATERIAL_TYPES.FABRIC && showFeaturesFilters && <FeaturesFilters toggleSelectedFeature={v => toggleSelectedFeature(v)} selectedFeatures={selectedFeatures} selectedFabric={selectedFabric} />;
    $[53] = selectedFabric;
    $[54] = selectedFeatures;
    $[55] = selectedMaterialType;
    $[56] = showFeaturesFilters;
    $[57] = toggleSelectedFeature;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== fabricTiers || $[60] !== selectedMaterialType || $[61] !== selectedTiers || $[62] !== showTierFilters || $[63] !== toggleSelectedTier) {
    t16 = selectedMaterialType === MATERIAL_TYPES.FABRIC && showTierFilters && <DesktopTierFilters fabricTiers={fabricTiers} toggleSelectedTier={v_0 => toggleSelectedTier(v_0)} selectedTiers={selectedTiers} />;
    $[59] = fabricTiers;
    $[60] = selectedMaterialType;
    $[61] = selectedTiers;
    $[62] = showTierFilters;
    $[63] = toggleSelectedTier;
    $[64] = t16;
  } else {
    t16 = $[64];
  }
  let t17;
  if ($[65] !== leatherGrades || $[66] !== selectedGrades || $[67] !== selectedMaterialType || $[68] !== showGradeFilters || $[69] !== toggleSelectedGrade) {
    t17 = selectedMaterialType === MATERIAL_TYPES.LEATHER && showGradeFilters && <DesktopGradeFilters leatherGrades={leatherGrades} toggleSelectedGrade={v_1 => toggleSelectedGrade(v_1)} selectedGrades={selectedGrades} />;
    $[65] = leatherGrades;
    $[66] = selectedGrades;
    $[67] = selectedMaterialType;
    $[68] = showGradeFilters;
    $[69] = toggleSelectedGrade;
    $[70] = t17;
  } else {
    t17 = $[70];
  }
  let t18;
  if ($[71] !== t11 || $[72] !== t13 || $[73] !== t14 || $[74] !== t15 || $[75] !== t16 || $[76] !== t17) {
    t18 = <TabletAndDesktopOnly><div className="max-[767px]:hidden pl-[3.333vw] pr-[3.333vw] [border-bottom:1px_solid_#f1f1f1] sticky top-[110px] z-[1000] bg-white [transition:transform_.2s_ease-in-out] max-[767px]:[border-bottom:1px_solid_#f1f1f1]"><div className="flex-wrap pt-6 px-0 pb-0 md:items-start md:flex md:min-h-[100px] md:mt-0 md:mb-0">{t11}{t13}{t14}{t15}{t16}{t17}</div></div></TabletAndDesktopOnly>;
    $[71] = t11;
    $[72] = t13;
    $[73] = t14;
    $[74] = t15;
    $[75] = t16;
    $[76] = t17;
    $[77] = t18;
  } else {
    t18 = $[77];
  }
  let t19;
  if ($[78] !== t18 || $[79] !== t8) {
    t19 = <>{t8}{t18}</>;
    $[78] = t18;
    $[79] = t8;
    $[80] = t19;
  } else {
    t19 = $[80];
  }
  return t19;
};
FabricPageHeader.propTypes = {
  // Filter/Data props
  selectedMaterialType: PropTypes.string,
  selectedColors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedFeatures: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedTiers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedGrades: PropTypes.arrayOf(PropTypes.number),
  selectedFabric: PropTypes.object,
  fabricColors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  fabricTiers: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  leatherGrades: PropTypes.arrayOf(PropTypes.number),
  sortBy: PropTypes.string,
  sortByOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })),
  showFavorites: PropTypes.bool,
  numberOfActiveFilters: PropTypes.number,
  showColorFilters: PropTypes.bool,
  showFeaturesFilters: PropTypes.bool,
  showTierFilters: PropTypes.bool,
  showGradeFilters: PropTypes.bool,
  // UI State props
  isMobileSortByOpen: PropTypes.bool,
  mobileItemsPerRow: PropTypes.number,
  mobileButtonItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    contentId: PropTypes.string,
    onClick: PropTypes.func
  })),
  bannerHeight: PropTypes.number,
  // Action props
  setSortBy: PropTypes.func,
  toggleSelectedColor: PropTypes.func,
  toggleSelectedFeature: PropTypes.func,
  toggleSelectedTier: PropTypes.func,
  toggleSelectedGrade: PropTypes.func,
  toggleMobileSortByOpen: PropTypes.func,
  toggleMobileItemsPerRow: PropTypes.func,
  toggleMobileFiltersOpen: PropTypes.func
};
export default FabricPageHeader;
function _temp(t0) {
  const {
    label: label_0,
    contentId,
    onClick
  } = t0;
  return {
    label: label_0,
    id: contentId,
    contentId,
    onClick
  };
}